<template>
  <FloatingPillButton variant="overlay" class="absolute top-4 z-20 generate-widget">
    <template #start>
      <AiBackgroundSelectIcon />
    </template>
    <template #center>
      {{ I18n.t("editor.magic_background.select_template") }}
    </template>
  </FloatingPillButton>
</template>

<script setup lang="ts">
import { FloatingPillButton, AiBackgroundSelectIcon } from "prism";
import { inject, onMounted } from "vue";

const I18n = inject("I18n");
const props = defineProps<{
  hideWidget: () => void;
}>();

onMounted(() => {
  setTimeout(() => {
    props.hideWidget();
  }, 4000);
});
</script>
<!-- Refactor this to use one class for all widgets -->
<style scoped>
.generate-widget {
  left: 50%;
  transform: translateX(-50%);
}
</style>
